import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const SkillFormContext = createContext({})

export const useSkillForm = () => useContext(SkillFormContext)

export const DEFAULT_SKILL_CONFIG = {
  audience: undefined,
  focuses: ['any'],
  modelId: null,
  maxIterations: null,
  temperature: null,
  maxTokens: null,
  iconName: 'cube',
  visible: true
}

function SkillFormProvider ({ children }) {
  const [skillId, setSkillId] = useState('')
  const [skillName, setSkillName] = useState('')
  const [description, setDescription] = useState('')
  const [useWhen, setUseWhen] = useState([])
  const [dontUseWhen, setDontUseWhen] = useState([])
  const [instructions, setInstructions] = useState('')
  const [defaultPrompt, setDefaultPrompt] = useState('')
  const [greetingMessage, setGreetingMessage] = useState('')
  const [skillConfig, setSkillConfig] = useState({ ...DEFAULT_SKILL_CONFIG })

  const hasContent = instructions.trim().length > 0

  const resetForm = useCallback(() => {
    setSkillId('')
    setSkillName('')
    setDescription('')
    setUseWhen([])
    setDontUseWhen([])
    setInstructions('')
    setDefaultPrompt('')
    setGreetingMessage('')
    setSkillConfig({ ...DEFAULT_SKILL_CONFIG })
  }, [])

  const value = useMemo(() => ({
    skillId,
    setSkillId,
    skillName,
    setSkillName,
    description,
    setDescription,
    useWhen,
    setUseWhen,
    dontUseWhen,
    setDontUseWhen,
    instructions,
    setInstructions,
    defaultPrompt,
    setDefaultPrompt,
    greetingMessage,
    setGreetingMessage,
    skillConfig,
    setSkillConfig,
    hasContent,
    resetForm
  }), [skillId, skillName, description, useWhen, dontUseWhen, instructions, defaultPrompt, greetingMessage, skillConfig, hasContent, resetForm])

  return (
    <SkillFormContext.Provider value={value}>
      {children}
    </SkillFormContext.Provider>
  )
}

SkillFormProvider.propTypes = {
  children: PropTypes.node
}

export default SkillFormProvider
